import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/user_roles/`, data);
};

const getGroup = async (id) => {
  return await httpClient.get(`/user_roles/${id}/get_group/`);
};

const getAllGroups = async () => {
  return await httpClient.get(`/user_roles/get_all_groups/`);
};

const getListByGroup = async (group_id) => {
  return await httpClient.get(`/user_roles/`, {
    params: { grupo: group_id },
  });
};

const getAll = async () => {
  return await httpClient.get(`/user_roles/`);
};

const get = async (id) => {
  return await httpClient.get(`/user_roles/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/user_roles/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/user_roles/${id}`);
};

export {
  post,
  getGroup,
  getAllGroups,
  getListByGroup,
  getAll,
  get,
  put,
  remove,
};
